// extracted by mini-css-extract-plugin
module.exports = {"profileAndSettingStyle":"_2lxnoE9jr6elP7SdsSnneH"};